<template>
    <div class="flex flex-col">
        <h3 class="mb-2 text-lg font-bold text-gray-400">
            Evolução do Score
        </h3>
        <line-chart
            :series="series"
            :loading="loading"
            :animate="true"
            :enable-point-click="true"
            :plot-lines="plotLines"
            @point-click="onPointClick"
        />
        <p v-if="plotLines.length" class="mt-1 text-[11px] text-amber-600 dark:text-amber-400">
            Linhas tracejadas: mudanças de regra de score no período ({{ plotLines.length }}).
        </p>
    </div>
</template>

<script>
import LineChart from "../../analytics/charts/LineChart.vue";

export default {
    components: { LineChart },
    props: ["user"],
    emits: ['score-selected'],
    data() {
        return {
            loading: true,
            series: [],
            scoresData: [],
            plotLines: [],
        };
    },
    mounted() {
        this.fetchScoreHistory();
    },
    methods: {
        filterClosePoints(scores) {
            if (scores.length <= 1) return scores;
            
            const minTimeGap = 3 * 24 * 60 * 60 * 1000; // 3 dias em milliseconds
            const filtered = [scores[0]]; // sempre inclui o primeiro ponto
            
            for (let i = 1; i < scores.length; i++) {
                const currentTime = new Date(scores[i].created_at).getTime();
                const lastTime = new Date(filtered[filtered.length - 1].created_at).getTime();
                
                // Se a diferença for maior que 3 dias OU for o último ponto, inclui
                if (currentTime - lastTime >= minTimeGap || i === scores.length - 1) {
                    filtered.push(scores[i]);
                }
            }
            
            return filtered;
        },

        /**
         * Mudancas de regra de score (TIC2-15569, X3) viram linhas verticais no grafico.
         * Sem permissao ou sem a tabela, simplesmente nao ha marcadores.
         */
        async fetchRuleEvents() {
            try {
                const { data } = await axios.get('/api/experimental-scores/rule-events', { params: { per_page: 100 } });
                return (data.data || [])
                    .filter((event) => event.changed_at_iso)
                    .map((event) => ({
                        value: new Date(event.changed_at_iso).getTime(),
                        color: '#f59e0b',
                        width: 1,
                        dashStyle: 'ShortDash',
                        zIndex: 4,
                        label: {
                            text: `${event.rule_name}: ${event.summary}`,
                            rotation: 90,
                            textAlign: 'left',
                            x: 4,
                            y: 12,
                            style: { color: '#f59e0b', fontSize: '9px' },
                        },
                    }));
            } catch (error) {
                return [];
            }
        },

        async fetchScoreHistory() {
            this.loading = true;
            try {
                const { data } = await axios.get(`/api/user/${this.user.id}/score/history`);
                const ruleEvents = await this.fetchRuleEvents();
                
                // Armazenar os dados completos para referência
                this.scoresData = data.scores;
                
                // Filtrar pontos muito próximos para melhor visualização
                const filteredScores = this.filterClosePoints(data.scores);
                
                const scoreSeries = {
                    name: "Score",
                    data: filteredScores.map((score) => ({
                        x: new Date(score.created_at).getTime(),
                        y: Number(score.amount),
                        pointData: {
                            id: score.id,
                            created_at: score.created_at
                        }
                    })),
                    lineWidth: 3,
                    marker: {
                        enabled: false, // Sem marcadores visíveis por padrão
                        symbol: 'circle'
                    }
                };
                
                const firstTime = filteredScores.length ? new Date(filteredScores[0].created_at).getTime() : 0;
                this.plotLines = ruleEvents.filter((line) => line.value >= firstTime);

                this.series = [scoreSeries];
                
            } catch (error) {
                console.error("Erro ao buscar histórico de scores:", error);
            } finally {
                this.loading = false;
            }
        },
        
        onPointClick(pointInfo) {
            if (pointInfo.pointData && pointInfo.pointData.id) {
                this.$emit('score-selected', pointInfo.pointData.id);
            }
        },
    }
};
</script>
